import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import Perfil from '../views/Perfil.vue'
import Curso from '../views/Curso.vue'
import Logout from '../views/Logout.vue'
import Checkout from '../views/Checkout.vue'
import CheckoutWay from '../views/CheckoutWay.vue'
import CheckoutMovil from '../views/CheckoutMovil.vue'
import Error404 from '../views/Error404.vue'
import Video from '../views/Video.vue'
import Registro from '../views/Registro.vue'
import Pagina from '../views/Pagina.vue'
import OlvidoPassword from '../views/OlvidoPassword.vue'
import RestablecerPassword from '../views/RestablecerPassword.vue'
import ActivarUsuario from '../views/ActivarUsuario.vue'
import CheckoutFinish from '../views/CheckoutFinish.vue'
import CheckoutThank from '../views/CheckoutThank.vue'
import HomeChangeMovil from '../views/HomeChangeMovil.vue'
import CheckoutAlternativeLanding from '../views/CheckoutAlternativeLanding.vue'
import CheckoutAlreadySoldLanding from '../views/CheckoutAlreadySoldLanding.vue'
import CheckoutCreditCardOnly from '../views/CheckoutCreditCardOnly.vue'

import CheckoutCodesLanding from '../views/CheckoutCodesLanding.vue'
import CheckoutLanding from "@/views/CheckoutLanding";
import CheckoutEntel from "../views/CheckoutEntel";
import CheckoutMovistar from "../views/CheckoutMovistar";
import CheckoutGMovistar from "../views/CheckoutGMovistar";
import FelicitacionesGMovistar from "../views/FelicitacionesGMovistar";
import LpEntel from "../views/LpEntel.vue";
import LpEntelHeader from "../views/LpEntelHeader.vue";
import LpMovistar from "../views/LpMovistar.vue";
import LpEntelFelicitaciones from "../views/FelicitacionesLpEntel.vue";
import LpMovistarFelicitaciones from "../views/FelicitacionesLpMovistar.vue";
import FelicitacionesLpMovistarParejas from "../views/FelicitacionesLpMovistarParejas.vue";


Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/curso/:guid_categoria/clase/:id_p_contenido/video/:id_p_video/:id_video',
            name: 'video',
            component: Video
        },
        {
            path: '/404',
            name: 'error404',
            component: Error404
        },
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/seleccionar-curso',
            name: 'HomeChangeMovil',
            component: HomeChangeMovil
        },
        {
            path: '/perfil',
            name: 'perfil',
            component: Perfil
        },
        {
            path: '/lp/evas/:productId',
            name: 'LpEntel',
            component: LpEntel
        },
        {
            path: '/lp/evasHeader/:productId',
            name: 'LpEntelHeader',
            component: LpEntelHeader
        },
        {
            path: '/felicitaciones/lp/evas/',
            name: 'LpEntelFelicitaciones',
            component: LpEntelFelicitaciones
        },
        {
            path: '/lp/movistar/:productId',
            name: 'LpMovistar',
            component: LpMovistar
        },
        {
            path: '/felicitaciones/lp/movistar/',
            name: 'LpMovistarFelicitaciones',
            component: LpMovistarFelicitaciones
        },
        {
            path: '/felicitaciones/lp/movistar/',
            name: 'LpMovistarFelicitacionesParejas',
            component: FelicitacionesLpMovistarParejas
        },
        {
            path: '/comprar/curso/:curso/:id',
            name: 'checkout',
            component: Checkout
        },
        {
            path: '/comprar/movistar/:curso/:id',
            name: 'CheckoutMovistar',
            component: CheckoutMovistar
        },
        {
            path: '/comprar/gmovistar/:curso/:id',
            name: 'CheckoutMovistar',
            component: CheckoutGMovistar
        },
        {
            path: '/comprar/gmovistar/felicitaciones/:curso/:id/:telefono',
            name: 'FelicitacionesGMovistar',
            component: FelicitacionesGMovistar
        },
        {
            path: '/comprar/evas/:curso/:id',
            name: 'CheckoutEntel',
            component: CheckoutEntel
        },
        //Checkout por landing page
        {
            path: '/comprar/curso/:curso/:id/landing',
            name: 'checkout-landing',
            component: CheckoutLanding
        },
        {
            path: '/operator/curso/:curso/:id',
            name: 'checkout-way',
            component: CheckoutWay
        },
        {
            path: '/comprar/:suscripcion/:id',
            name: 'checkout-prime',
            component: Checkout
        },/*,
        {
            path: '/checkout/:vista/:id',
            name: 'checkout-vista',
            component: Checkout
        }*/,
        {
            path: '/:pasarela/checkout/:estado/:id_compra',
            name: 'CheckoutFinish',
            props: true,
            component: CheckoutFinish
        },
        {
            path: '/gracias/:estado/:id_compra',
            name: 'CheckoutThank',
            component: CheckoutThank
        },
        {
            path: '/checkout-movil/:id_producto/:id_portal_pasarela',
            name: 'checkout-movil',
            component: CheckoutMovil
        },
        {
            path: '/curso/:guid',
            name: 'curso',
            component: Curso
        }/*,
        {
            path: '/curso/:vista/:guid',
            name: 'curso-vista',
            component: Curso
        }*/,
        {
            path: '/pagina/:guid',
            name: 'pagina',
            component: Pagina
        },
        {
            path: '/salir',
            name: 'logout',
            component: Logout
        },
        {
            path: '/olvido_password',
            name: 'olvido_password',
            component: OlvidoPassword
        },
        {
            path: '/restablecer_password/:token',
            name: 'restablecer_password',
            component: RestablecerPassword
        },
        {
            path: '/activar_usuario/:token',
            name: 'activar_usuario',
            component: ActivarUsuario
        },
        {
            path: '/shared/:user',
            name: 'shared',
            component: Home
        },
        {
            path:'/comprar/curso/alternative/:curso/:id',
            name:'checkoutAlternativeLanding',
            component: CheckoutAlternativeLanding
        },
        {
            path:'/comprar/curso/code/:curso/:id',
            name:'checkoutCodesLanding',
            component: CheckoutCodesLanding
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import( /* webpackChunkName: "about" */ '../views/About.vue')
        },
        {
            path:'/comprar/curso/alreadysoldlanding/:curso/:id',
            name:'CheckoutAlreadySoldLanding',
            component: CheckoutAlreadySoldLanding
        },
        {
            path:'/comprar/curso/creditcardonly/:curso/:id',
            name:'CheckoutCreditCardOnly',
            component: CheckoutCreditCardOnly
        }
    ]
})

router.beforeEach((to, from, next) => {
    window.scroll(0, 0);
    next(vm => {
        vm.$store.dispatch('checkUserActivado', vm.$route.name)
        vm.$store.commit('updateSite', {
            isPortalLoginModalVisible: false,
            isPortalRegistroModalVisible: false,
            isTransferenciaModalVisible: false,
            isCompletarPerfilModalVisible: false,
            isSiteMenuVisible: false
        })
    })

})

export default router
